import React from 'react';

const Figure = ({ title, titleClassName, children, className }) => {
	return (
		<div>
			{title && (
				<div
					className={`
						px-2 py-1 bg-gray-200
						${titleClassName ?? ''}
					`}
				>
					{title}
				</div>
			)}

			<div
				className={`
					flex flex-col border border-gray-200 divide-y divide-gray-200
					${className ?? ''}
				`}
			>
				{children}
			</div>
		</div>
	);
};

export default Figure;
